export default __webpack_public_path__ + "static/media/Geist-VariableFont_wght.8a7e051c.ttf";